import { Documents } from '../documents'

export const ExpertDocuments = Documents
